export default {
  GET_AUDIT_RECORDS: ({ page = 1, rowsPerPage = 100, startDate, endDate, branchId }) =>
    `audits/?page=${page}&page_size=${rowsPerPage}`,
  // `audits/?location_id=${branchId}&start_date=${startDate}&end_date=${endDate}&reconciled=0&page=${page}&page_size=${rowsPerPage}`,
  GET_ASSET_AUDIT_RECORDS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `audits/?asset_id=${id}&page=${page}&page_size=${rowsPerPage}`,

  GET_ASSET_AUDIT_DETAILS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `audits/${id}/items/?page=${page}&page_size=${rowsPerPage}`,
  CREATE_AUDIT_RECORD: 'audits/',
  SAVE_AUDITED_RECORDS: 'audits/save-audited/',
  SUBMIT_AUDIT_REQUEST: (id) => `audits/${id}/save-audited/`,
  RECONCILE_AUDIT_RECORD: 'audits/reconciliation/',
  SEARCH_ASSET_BY_BARCODE: (barcode) => `assets/?barcode_number=${barcode}`,
  DELETE_AUDIT_RECORD: (id) => `audits/${id}/delete/`,
  UPDATE_ASSET: (id) => `assets/${id}/update/`,
  DELETE_ASSET: (id) => `assets/${id}/delete/`,
};
